import { Modal } from '@/components';
import gmailIcon from '../../assets/gmail_icon.png';
import whatsappIcon from '../../assets/WhatsApp_icon.png';
import { ChannelAvailabilityState } from '../../components/ChannelAvailabilityState';

export function ReminderImportChannelModal({
  isOpen,
  onClose,
  onSelectChannel,
  status,
  canOpenSettings = false,
}) {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      showClose={false}
      panelClassName="!p-6 !rounded-[20px] font-sans"
    >
      {/* Custom Header with Theme Green Close Button */}
      <div className="flex items-start justify-between w-full border-b border-[#EBF4EA] pb-4 mb-4">
        <div>
          <h2 className="text-lg font-bold text-[#1F2241]">
            Select Import Channel
          </h2>
          <p className="text-xs text-[#868686] mt-0.5 font-medium">
            Choose which type of reminders you want to import
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="w-7 h-7 rounded-[8px] bg-primary text-white flex items-center justify-center hover:bg-primary-hover transition-colors focus:outline-none shrink-0 cursor-pointer"
          aria-label="Close"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      {/* Options Body */}
      <div className="flex flex-col gap-3 py-1">
        <ChannelAvailabilityState
          status={status}
          canOpenSettings={canOpenSettings}
        >
          {status?.email ? (
            <button
              type="button"
              onClick={() => {
                onSelectChannel('email');
                onClose();
              }}
              className="flex items-center gap-4 p-4 rounded-xl border border-[#EBF4EA] bg-white hover:border-primary hover:bg-[#EBF4EA]/30 transition-all text-left group cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-blue-50/80 border border-blue-100/80 flex items-center justify-center p-2 group-hover:scale-105 transition-transform shrink-0">
                <img
                  src={gmailIcon}
                  alt="Email (Gmail)"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-bold text-[#1F2241] text-sm group-hover:text-primary transition-colors">
                  Email Reminders
                </h4>
                <p className="text-xs text-[#868686] mt-0.5 leading-relaxed font-medium">
                  Import email reminders from a spreadsheet
                </p>
              </div>
              <div className="w-7 h-7 rounded-full bg-[#F5F5F5] group-hover:bg-primary text-[#868686] group-hover:text-white transition-colors flex items-center justify-center shrink-0">
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                  />
                </svg>
              </div>
            </button>
          ) : null}

          {status?.whatsapp ? (
            <button
              type="button"
              onClick={() => {
                onSelectChannel('whatsapp');
                onClose();
              }}
              className="flex items-center gap-4 p-4 rounded-xl border border-[#EBF4EA] bg-white hover:border-primary hover:bg-[#EBF4EA]/30 transition-all text-left group cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-emerald-50/80 border border-emerald-100/80 flex items-center justify-center p-2 group-hover:scale-105 transition-transform shrink-0">
                <img
                  src={whatsappIcon}
                  alt="WhatsApp"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-bold text-[#1F2241] text-sm group-hover:text-primary transition-colors">
                  WhatsApp Reminders
                </h4>
                <p className="text-xs text-[#868686] mt-0.5 leading-relaxed font-medium">
                  Import WhatsApp template reminders from a spreadsheet
                </p>
              </div>
              <div className="w-7 h-7 rounded-full bg-[#F5F5F5] group-hover:bg-primary text-[#868686] group-hover:text-white transition-colors flex items-center justify-center shrink-0">
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                  />
                </svg>
              </div>
            </button>
          ) : null}
        </ChannelAvailabilityState>
      </div>

      {/* Footer with Theme Secondary Cancel Button */}
      <div className="flex justify-end pt-4 mt-3 border-t border-[#EBF4EA]">
        <button
          type="button"
          onClick={onClose}
          className="h-10 px-6 rounded-xl border border-primary text-primary hover:bg-surface-mint text-sm font-semibold transition-colors focus:outline-none cursor-pointer"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
}
